import { isDefined } from "@ls/js-utils";
import SummaryType from "state/selections/Constants/SummaryType";
import scope from "./scope";

export default class AnalyticDefinition {
  static getDefault = () =>
    new AnalyticDefinition({
      analytic: "weight",
      scaleType: "Contribution",
      summary: SummaryType.ABSOLUTE,
    });

  #analytic;
  #scaleType;
  #summary;

  constructor({ analytic, scaleType, summary }) {
    this.#analytic = analytic;
    this.#scaleType = scaleType ?? "Contribution";
    this.#summary = summary;
  }

  get analytic() {
    return this.#analytic;
  }
  get scaleType() {
    return this.#scaleType;
  }
  get summary() {
    return this.#summary;
  }
  get complete() {
    return (
      isDefined(this.analytic) &&
      isDefined(this.scaleType) &&
      isDefined(this.summary)
    );
  }
  get key() {
    return `${scope} - ${this.analytic}, ${this.scaleType}, ${this.summary}`;
  }

  setAnalytic = (value) =>
    new AnalyticDefinition({
      ...this.copy(),
      analytic: value,
    });

  setScaleType = (value) =>
    new AnalyticDefinition({
      ...this.copy(),
      scaleType: value,
      summary: value === "RATIO" ? SummaryType.RELATIVE : this.summary,
    });

  setSummary = (value) =>
    new AnalyticDefinition({
      ...this.copy(),
      summary: value,
    });

  copy = () => {
    return {
      analytic: this.analytic,
      scaleType: this.scaleType,
      summary: this.summary,
    };
  };
}
